import store from "../store/index.js";

export default class Auth {
  static async isSignedIn() {
    if (store.getters["users/isAuthenticated"]) {
      return true;
    } else {
      return false;
    }
  }

  // TODO: Brauch man das tatsächlich ?
  static async stateLoaded() {
    if (store.state["configuration"].app) {
      return true;
    } else {
      return false;
    }
  }

  // TODO: Warum hier nicht async?
  static userDisplayName() {
    if (store.getters["users/user"]) {
      return store.getters["users/user"].displayName;
    } else {
      return "";
    }
  }

  static getUserAvatar() {
    if (store.getters["users/user"]) {
      return store.getters["users/user"].avatar || "";
    }
  }

  static getUserId() {
    if (store.getters["users/user"]) {
      return store.getters["users/user"].id || "";
    }
  }

  static getUserEmail() {
    if (store.getters["users/user"]) {
      return store.getters["users/user"].email || "";
    }
  }
}
